<template>
    <div class="container py-5 ">
        <div class="breadcrumbs py-5">
            <a href="/home">Inicio</a>
            <a class="link" href="#">Mi Perfil</a>
        </div>

        <div class="header-catalog">
            <h5>Mi Perfil</h5>
        </div>

        <div class="row header-profile">
            <div class="col-sm-12 col-md-6 my-3 my-sm-1">
                <div class="profile">
                    <div class="img-profile">
                        <img src="/img-version2/icons/profile-blue.svg" alt="">
                    </div>

                    <div class="info-profile">
                        <h6>{{ user.name }}</h6>
                        <div v-if="change_password_roles.includes(segmentation_id)">
                            <span>Identificación: {{ user.identification_number }}</span> <br>
                            <a href="/cambiar-password">Cambiar contraseña</a>
                        </div>
                        <div v-else>
                            <span>Código: {{ pdv_info ? pdv_info.insitu_code : null }}</span> <br>
                            <a href="/cambiar-password">Cambiar contraseña</a>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="tier_segments.includes(segmentation_id) && sales_representative && sales_representative.length > 0" class="col-sm-12 col-md-6 my-3 my-sm-1">
                <div class="descr-profile">
                    <div class="header">
                        <h6>Representante de venta</h6>
                    </div>
                    <div v-for="item in sales_representative">
                        <div class="content">
                            <span>Nombre: {{ item.sales_rep_name }}</span>
                            <span>Teléfono: {{ item.sales_rep_phone }}</span>
                        </div>
                        <div class="content">
                            <span>Día de visita: {{ item.visit_days }}</span>
                        </div>
                        <hr v-if="sales_representative.length > 1">
                    </div>
                </div>
            </div>
        </div>
        <div class="row content-profile">
            <div class="col-sm-12 col-md-6">
                <div class="tabs">
                    <ul class="nav nav-pills mb-3">
                        <li class="nav-item" role="presentation">
                            <button @click="change_tab('history_points')" :class="current_tab === 'history_points' ? 'active' : ''" class="nav-link" type="button" role="tab" aria-controls="pills-home" :aria-selected="current_tab === 'history_points' ? true : false">Historial de Puntos</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button @click="change_tab('my_redemptions')" :class="current_tab === 'my_redemptions' ? 'active' : ''" class="nav-link" type="button" role="tab" aria-controls="pills-profile" :aria-selected="current_tab === 'my_redemptions' ? true : false">Mis Redenciones</button>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-sm-12 col-md-6">
                <div v-if="current_tab === 'history_points'">
                    <div class="filter-month">
                        <form>
                            <select v-model="selected_month_points" id="select-month" name="Meses" @change="getHistoryPoints(1)">
                                <option value="all">Todos</option>
                                <option v-for="month in points_months" :value="month.value">{{ month.key }}</option>
                            </select>
                        </form>
                    </div>
                </div>
            </div>

            <div v-if="current_tab === 'history_points'">
                <div v-if="history_points && history_points.data.length !== 0">
                    <div class="row justify-content-center p-3 py-5">
                        <div v-for="transaction in history_points.data" :key="transaction.id" class="col-lg-4 col-md-12 card-points my-3 my-sm-1">
                            <div class="header">
                                <h6>{{ transaction.transaction_detail }}</h6>
                                <div class="box-points">
                                    <img src="/img-version2/icons/coin-china.svg" alt="">
                                    <span class="points"><strong>{{ transaction.transaction_type_id == 1 ? '+' : '-' }} {{ Math.floor(transaction.amount) }}</strong></span>
                                    <span>Pts</span>
                                </div>
                            </div>
                            <div class="footer">
                                <p> <strong>Fecha:</strong> {{ formatDate(transaction.created_at) }}</p>
                                <p><strong>Estado:</strong> {{ transaction.transaction_status.name }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center" v-if="history_points.last_page !== 1">
                        <div class="col-md-6 d-flex justify-content-center">
                            <div class="pagination my-2">
                                <a class="back" :class="history_points.prev_page_url === null ? 'disable' : ''">
                                    <span v-if="history_points.current_page-1 > 1" @click="getHistoryPoints(history_points.current_page - 1)"><</span>
                                    <span v-else><</span>
                                </a>
                                <a v-if="history_points.current_page-2 > 1" @click="getHistoryPoints(1)" class="p-2">{{ 1 }}</a>
                                <a v-if="history_points.current_page-2 >= 1" class="p-2">...</a>
                                <a v-if="history_points.current_page > 1" @click="getHistoryPoints(history_points.current_page - 1)" class="p-2">{{ history_points.current_page - 1 }}</a>
                                <a class="p-2">{{ history_points.current_page }}</a>
                                <a v-if="history_points.current_page < history_points.last_page" @click="getHistoryPoints(history_points.current_page + 1)" class="p-2">{{ history_points.current_page + 1 }}</a>
                                <a v-if="history_points.current_page+2 <= history_points.last_page" class="p-2">...</a>
                                <a v-if="history_points.current_page+2 < history_points.last_page" @click="getHistoryPoints(history_points.last_page)" class="p-2">{{ history_points.last_page }}</a>
                                <a class="next" :class="history_points.current_page >= history_points.last_page ? 'disable' : ''">
                                    <span v-if="history_points.current_page !== history_points.last_page" @click="getHistoryPoints(history_points.current_page + 1)">></span>
                                    <span v-else>></span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="container-fluid py-5 no-found">
                        <img src="/img-version2/brand/no-found.png" alt="no found">
                        <span>Aun no tienes un historial de puntos para ver</span>
                    </div>
                </div>
            </div>

            <div v-if="current_tab === 'my_redemptions'">
                <div v-if="my_redemptions !== null && my_redemptions.data.length !== 0">
                    <div class="row justify-content-center py-5">
                        <div class="col-lg-4 col-md-12 card-reden my-3 my-sm-1" v-for="(redemption, index) in my_redemptions.data" :key="index">
                            <div class="header">
                                <span class="tag-entregado" v-if="redemption.StatusName === 'Aprobado'">{{ redemption.StatusName }}</span>
                                <span class="tag-despachado" v-else-if="redemption.StatusName === 'En proceso de aprobación'">Solicitado</span>
                                <div class="box-points">
                                    <img src="/img-version2/icons/coin-china.svg" alt="coin">
                                    <span class="points"><strong>{{ Math.floor( (redemption.PointsUnitValue) + (redemption.PointsUnitShippingValue?redemption.PointsUnitShippingValue:0) ) }}</strong></span>
                                    <span>Pts</span>
                                </div>
                            </div>
                            <div class="content">
                                <div class="img-reden">
                                    <img v-if="redemption.ProductImage" :src="my_redemptions.domain + redemption.ProductImage.replace('~/', '')" :alt="redemption.ProductName" width="100%">
                                    <img v-else :src="my_redemptions.domain + redemption.ProductImage" :alt="redemption.ProductName">
                                </div>
                                <div class="inf-reden">
                                    <h6>{{ redemption.ProductName }}</h6>
                                    <p v-if="redemption.CodigoDigital !== null">Codigo: <span>{{ redemption.CodigoDigital }}</span></p>
                                    <p v-if="redemption.CodigoDigital !== null">Expiración del codigo: <span>{{ redemption.DigitalProductExpirationDate }}</span></p>
                                    <p>Redimido: <span>{{ formatDate(redemption.OrderDate) }}</span></p>
                                    <p v-if="redemption.CodigoDigital === null">cantidad: <span>{{ redemption.QUANTITY }}</span></p>
<!--                                    <p>Direccion: <span>Calle 127B #45-23</span></p>-->
                                    <p>Numero de guia: <span>{{ redemption.OrderGuid }}</span></p>
                                </div>
                            </div>
                            <div class="footer">
                                <p>{{ redemption.ProviderName }}</p>
                            </div>
                        </div>

                    </div>
                    <div class="row justify-content-center" v-if="my_redemptions.last_page > 1">
                        <div class="col-md-6 d-flex justify-content-center">
                            <div class="pagination my-2">
                                <a class="back" :class="my_redemptions.prev_page_url === null ? 'disable' : ''">
                                    <span v-if="my_redemptions.current_page-1 > 1" @click="getHistoryPoints(my_redemptions.current_page - 1)"><</span>
                                    <span v-else><</span>
                                </a>
                                <a v-if="my_redemptions.current_page-2 > 1" @click="getHistoryPoints(1)" class="p-2">{{ 1 }}</a>
                                <a v-if="my_redemptions.current_page-2 >= 1" class="p-2">...</a>
                                <a v-if="my_redemptions.current_page > 1" @click="getHistoryPoints(my_redemptions.current_page - 1)" class="p-2">{{ my_redemptions.current_page - 1 }}</a>
                                <a class="p-2">{{ my_redemptions.current_page }}</a>
                                <a v-if="my_redemptions.current_page < my_redemptions.last_page" @click="getHistoryPoints(my_redemptions.current_page + 1)" class="p-2">{{ my_redemptions.current_page + 1 }}</a>
                                <a v-if="my_redemptions.current_page+2 <= my_redemptions.last_page" class="p-2">...</a>
                                <a v-if="my_redemptions.current_page+2 < my_redemptions.last_page" @click="getHistoryPoints(my_redemptions.last_page)" class="p-2">{{ my_redemptions.last_page }}</a>
                                <a class="next" :class="my_redemptions.current_page >= my_redemptions.last_page ? 'disable' : ''">
                                    <span v-if="my_redemptions.current_page !== my_redemptions.last_page" @click="getHistoryPoints(my_redemptions.current_page + 1)">></span>
                                    <span v-else>></span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="container-fluid py-5 no-found">
                        <img src="/img-version2/brand/no-found.png" alt="no found">
                        <span>Aun no has realizado redenciones</span>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        user: {
            default: null,
        },
        pdv_info: {
            default: null,
        },
        segmentation_id: {
            default: 0,
        }
    },
    data() {
        return {
            loading: 0,
            current_tab: 'history_points',
            history_points: null,
            my_redemptions: null,
            tier_segments: [1, 2, 3, 4],
            change_password_roles: [12, 5, 13],
            points_months: null,
            selected_month_points: 'all',
            sales_representative: null,
        }
    },
    mounted () {
        this.getHistoryPoints(1)
        if(this.tier_segments.includes(this.segmentation_id)){
            this.getSalesRepresentative()
        }
    },
    methods: {
        change_tab(new_tab) {
            this.current_tab = new_tab
            if(this.current_tab === 'history_points' && this.history_points === null){
                this.getHistoryPoints(1)
            }else if(this.current_tab === 'my_redemptions' && this.my_redemptions === null){
                this.getMyRedemptions(1)
            }
        },
        getHistoryPoints(page){
            this.loading++
            axios.get(`/points?page=${page}&month=${this.selected_month_points}`)
                 .then(({data}) => {
                     this.history_points = data.transactions
                     this.points_months = data.history_months
                     this.loading--;
                 })
        },
        getMyRedemptions(page){
            this.loading++
            axios.get(`/my-redemption?page=${page}`)
                 .then(({data}) => {
                     this.my_redemptions = data
                     this.loading--
                 })
        },
        formatDate(date){
            const newDate = new Date(date)
            return `${newDate.getDate()}/${newDate.getMonth()+1 < 10 ?`0${newDate.getMonth()+1}`: newDate.getMonth()+1 }/${newDate.getFullYear()}`
        },
        getSalesRepresentative(){
            this.loading++
            axios.get(`/sales-representative`)
                 .then(({data}) => {
                     this.sales_representative = data
                     this.loading--
                 })
        }
    },
}
</script>

<style scoped>

.pagination {
    .back{
        padding: 0 20px;
        text-decoration: none;
        color: #C1C1C1;
        font-size: 10px;
    }
    .number {
        padding: 0 20px;
        text-decoration: none;
        color: #C1C1C1;
        font-size: 10px;
    }
    .active{
        padding: 0 20px;
        text-decoration: none;
        color: #F87C00;
        font-weight: 700 !important;
        font-size: 14px !important;
        margin-top: -4px;
    }
    .next{
        padding: 0 20px;
        text-decoration: none;
        color: #C1C1C1;
        font-size: 10px;
    }
}

</style>